import {vuepayAlert} from "./utility";
import moment from 'moment';
import {X_AUTHORIZATION} from "./constants";
//internal js
import CryptoJS from 'crypto-js';
import {getMoneyBloxWalletBalance} from "../assets/libs/MoneyBlox";

//constants for storage
export const LOGIN = "VUEPAY_LOGIN";
export const USER_DATA = "VUEPAY_USERDATA";

//this is only for moneyblox
const MONEYBLOX_LOGIN = "MONEYBLOX_LOGIN";
const MONEYBLOX_USERDATA = "MONEYBLOX_USERDATA";

//functions
export const getData = async (key) => {
    try {
        const storedValue = await sessionStorage.getItem(key);
        if (typeof storedValue === 'undefined') {
            return {};
        } else {
            const bytes = CryptoJS.AES.decrypt(storedValue.toString(),X_AUTHORIZATION);
            const plaintext = bytes.toString(CryptoJS.enc.Utf8);
            return JSON.parse(plaintext);
        }
    } catch (error) {
        //TODO
        //vuepayAlert("error", "There was error while loading the data");
    }
};

export const setData = async (key, data, callback) => {
    try {
        const encrypted_data = CryptoJS.AES.encrypt(JSON.stringify(data),X_AUTHORIZATION);
        await sessionStorage.setItem(key,encrypted_data);
        if (callback !== null && typeof callback === "function") {
            callback();
        }
    } catch (error) {
        console.log(error)
        //vuepayAlert("error", "There was error while loading the data");
    }
};

export const redirectIfSessionExist = (callback) => {

    getData(LOGIN)
        .then((data) => {
            if (data !== null && data !== undefined && data.hasOwnProperty("ttl")) {
                const now = moment()
                const ttl = moment.unix(data.ttl)
                const diff = ttl.diff(now, 'hours')
                if (diff >= 0 && callback !== null && typeof callback === "function") {
                    callback(true);
                } else {
                    callback(false);
                }
            } else {
                callback(false);
            }
        });
}

export const clearStorage = async () => {
    try {
        await sessionStorage.removeItem(LOGIN);
        await sessionStorage.removeItem(USER_DATA);
        await localStorage.removeItem(MONEYBLOX_LOGIN);
        await localStorage.removeItem(MONEYBLOX_USERDATA);
        return true;
    } catch (error) {
        return false;
        //TODO
    }
}